<script>
    import {bindCar} from '@/api';

    export default {
        props: {
            carNo: String,
            label: {
                type: String,
                value: '请输入您的车牌号码'
            }
        },
        data() {
            return {
                provinceOrCity: '',
                carNumberArray: [],
                setDefaultCarNumber: false,
                showProvinceOrCityBoard: false, // 是否显示汉字键盘
                showCharOrNumberBoard: false,   // 是否显示英文数字键盘
                shortNames: [
                    ['渝', '川', '鄂', '陕', '京', '津', '沪', '冀', '豫'],
                    ['云', '辽', '黑', '湘', '皖', '鲁', '新', '苏', '浙'],
                    ['赣', '桂', '甘', '晋', '蒙', '吉', '闽', '贵'],
                    ['粤', '青', '藏', '琼', '宁', 'W', '←']
                ],
                carNumbers: [
                    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
                    ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'P', '学', '军'],
                    ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', '警'],
                    ['Z', 'X', 'C', 'V', 'B', 'N', 'M', '港', '澳', '←']
                ]
            };
        },
        computed: {
            carNumberIsValid() {
                // 车牌号至少7位，除去省市简称
                return this.carNumber.length > 6;
            },
            carNumber() {
                // 完整的车牌号
                return this.provinceOrCity + this.carNumberArray.join('');
            },
            showKeyboard() {
                // 键盘是否处于显示状态
                return this.showProvinceOrCityBoard || this.showCharOrNumberBoard;
            }
        },
        mounted() {
            this.parseCarNo(this.carNo);
        },
        watch: {
            carNo(value) {
                if (value !== this.carNumber) {
                    this.closeKeyboard();
                }

                this.parseCarNo(value);
            }
        },
        methods: {
            parseCarNo(carNo) {
                if (carNo && carNo.length > 6) {
                    carNo = carNo.toUpperCase();
                    this.provinceOrCity = carNo.substr(0, 1);
                    this.carNumberArray = carNo.substr(1).split('');
                } else {
                    this.provinceOrCity = '';
                    this.carNumberArray = [];
                }
            },
            // 唤起键盘
            clickShowKeyboard() {
                if (!this.provinceOrCity) {
                    this.showProvinceOrCityBoard = true;
                } else {
                    this.showProvinceOrCityBoard = false;
                    this.showCharOrNumberBoard = true;
                }
            },
            // 关闭键盘
            closeKeyboard() {
                this.showProvinceOrCityBoard = false;
                this.showCharOrNumberBoard = false;
            },
            // 选择车牌号前面的汉字
            inputProvinceOrCity(name) {
                // 如果点击删除键，删除第一个格的内容
                if (name === '←') {
                    this.provinceOrCity = ''
                } else {
                    // 把选中的字赋值给第一个格，并且切换键盘
                    this.provinceOrCity = name;
                    this.showProvinceOrCityBoard = false;
                    this.showCharOrNumberBoard = true;
                }
            },
            // 选择车牌号后面的数字和字母
            inputCharOrNumber(name) {
                // 车牌号第二位不能是数字
                if (!isNaN(name) && this.carNumberArray.length === 0) {
                    return;
                }

                // 如果点击删除键，删除 carNumberArray 的最后一个值
                if (name === '←') {
                    this.carNumberArray.pop();
                    // 如果 carNumberArray 里面被删的没有值了，切换键盘
                    if (this.carNumberArray.length === 0) {
                        this.showProvinceOrCityBoard = true;
                        this.showCharOrNumberBoard = false;
                    }
                } else {
                    if (this.carNumberArray.length === 7) {
                        this.carNumberArray.pop()
                    }

                    this.carNumberArray.push(name);

                    if (this.carNumberArray.length === 7) {
                        this.closeKeyboard();
                    }

                    if (this.carNumberIsValid) {
                        this.$emit('car-number-valid', this.carNumber);
                    }
                }
            },
            // 设为默认车牌号
            checkSetDefault() {
                if (!this.carNumberIsValid) {
                    return false;
                }

                bindCar({carNumber: this.carNumber, isDefault: !this.setDefaultCarNumber}).then(response => {
                    if (response.data.code === '000000') {
                        this.setDefaultCarNumber = !this.setDefaultCarNumber;
                    }
                });
            }
        }
    }
</script>

<template>
    <div id="carNumberKeyboard">
        <div class="content">
            <div class="car-number">
                <div class="label">{{label}}</div>
                <div class="number">
                    <div class="item" @click="clickShowKeyboard">{{provinceOrCity}}</div>
                    <div class="item" @click="clickShowKeyboard">{{carNumberArray[0]}}</div>
                    <div class="sdt-dot"></div>
                    <div class="item" @click="clickShowKeyboard">{{carNumberArray[1]}}</div>
                    <div class="item" @click="clickShowKeyboard">{{carNumberArray[2]}}</div>
                    <div class="item" @click="clickShowKeyboard">{{carNumberArray[3]}}</div>
                    <div class="item" @click="clickShowKeyboard">{{carNumberArray[4]}}</div>
                    <div class="item" @click="clickShowKeyboard">{{carNumberArray[5]}}</div>
                    <div class="item new" @click="clickShowKeyboard">
                        <div class="type">新能源</div>
                        {{carNumberArray[6]}}
                    </div>
                </div>
                <div class="row">
                    <div></div>
                    <div class="check" @click="checkSetDefault">
                        <div :class="{'sdt-check-off': !setDefaultCarNumber, 'sdt-check-on': setDefaultCarNumber}" class="radio"/>
                        <div class="text">设为默认车牌</div>
                    </div>
                </div>
            </div>
            <slot></slot>
        </div>
        <div v-if="showKeyboard" class="keyboard">
            <div class="top">
                <div class="sdt-keyboard"></div>
                <div class="complete" @click="closeKeyboard">完成</div>
            </div>
            <div v-if="showProvinceOrCityBoard" class="province-city">
                <div v-for="(row, i) in shortNames" :key="i" class="row">
                    <div v-for="name in row" :key="name" @click="inputProvinceOrCity(name)" class="item">
                        <template v-if="name === '←'">
                            <div class="sdt-delete-keyboard"></div>
                        </template>
                        <template v-else>{{name}}</template>
                    </div>
                </div>
            </div>
            <div v-if="showCharOrNumberBoard" class="char-number">
                <div v-for="(row, j) in carNumbers" :key="j" class="row">
                    <div v-for="name in row" :key="name" @click="inputCharOrNumber(name)" :class="carNumberArray.length === 0 && j === 0 ? 'grey' : ''" class="item">
                        <template v-if="name === '←'">
                            <div class="sdt-delete-keyboard"></div>
                        </template>
                        <template v-else>{{name}}</template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    #carNumberKeyboard {
        display: flex;
        flex-direction: column;
    }

    #carNumberKeyboard .content {
        flex: 1;
    }

    #carNumberKeyboard .content .car-number {
        margin-top: 16px;
        text-align: center;
    }

    #carNumberKeyboard .content .car-number .label {
        padding: 8px;
        color: #333333;
        font-size: 18px;
        font-weight: bold;
    }

    #carNumberKeyboard .content .car-number .number {
        display: flex;
        margin-top: 8px;
        text-align: center;
        align-items: center;
        justify-content: center;
    }

    #carNumberKeyboard .content .car-number .number .item {
        width: 36px;
        height: 36px;
        margin: 0 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #009251;
    }

    #carNumberKeyboard .content .car-number .number .sdt-dot {
        color: gray;
        font-size: 16px;
        text-align: center;
    }

    #carNumberKeyboard .content .car-number .number .new {
        position: relative;
        border: 1px dashed #009251;
    }

    #carNumberKeyboard .content .car-number .number .item.new .type {
        position: absolute;
        top: -6px;
        color: white;
        font-size: 7px;
        padding: 2px 4px;
        letter-spacing: 0;
        border-radius: 8px;
        white-space: nowrap;
        background-color: #49C628;
    }

    #carNumberKeyboard .content .row {
        display: flex;
        color: #666666;
        align-items: center;
        padding: 8px 16px 0 16px;
        justify-content: space-between;
    }

    #carNumberKeyboard .content .row .check {
        display: flex;
        font-size: 12px;
        align-items: center;
    }

    #carNumberKeyboard .content .row .check .radio {
        color: #999999;
    }

    #carNumberKeyboard .content .row .check .text {
        margin-left: 2px;
    }

    #carNumberKeyboard .keyboard {
        background-color: #e1e3e7;
        box-shadow: 0 -1px 2px #e9e9e9;
    }

    #carNumberKeyboard .keyboard .top {
        padding: 8px;
        display: flex;
        color: #808388;
        align-items: center;
        background-color: white;
        justify-content: space-between;
    }

    #carNumberKeyboard .keyboard .top .sdt-keyboard {
        font-size: 22px;
    }

    #carNumberKeyboard .keyboard .top .complete {
        color: #666666;
        font-size: 14px;
        font-weight: bold;
    }

    #carNumberKeyboard .keyboard .char-number,
    #carNumberKeyboard .keyboard .province-city {
        display: flex;
        padding: 8px 0;
        align-items: center;
        flex-direction: column;
    }

    #carNumberKeyboard .keyboard .row {
        display: flex;
    }

    #carNumberKeyboard .keyboard .row .item + .item {
        margin-left: 8px;
    }

    #carNumberKeyboard .keyboard .row + .row {
        margin-top: 8px;
    }

    #carNumberKeyboard .keyboard .item {
        height: 34px;
        display: flex;
        color: #0b0b0b;
        border-radius: 4px;
        align-items: center;
        justify-content: center;
        background-color: white;
    }

    #carNumberKeyboard .keyboard .province-city .item {
        width: 34px;
    }

    #carNumberKeyboard .keyboard .char-number .item {
        width: 30px;
    }

    #carNumberKeyboard .keyboard .item.grey {
        color: #dadada;
    }

    #carNumberKeyboard .keyboard .item .sdt-delete-keyboard {
        color: #808080;
        font-size: 18px;
    }
</style>
